import { useMemo } from 'react';

import type { TAdfoxContextData } from '../../types';
import type { TPParams } from '../../../../../types';
import { usePuids } from '../../../../../../../hooks';
import { getCalculatedParams, getRandomId } from '../utils';

type Params = TAdfoxContextData['params'];

export const PR_RANDOM = getRandomId();

export function useAdfoxParams(pParams: TPParams): Params {
  const puids = usePuids();

  return useMemo((): Record<string, string> => {
    return {
      ...pParams,
      ...getCalculatedParams(),
      pr: PR_RANDOM,
      ...puids,
    };
  }, [pParams, puids]);
}
